import React, { Component } from 'react'
import { Table, Row, Pagination } from "antd"
import config from "app/config"
import Lightbox from "react-image-lightbox"
import { observer } from "mobx-react"
// import downloadIcon from "app/styles/images/sp/download.svg"

@observer
class ReportDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false,
      isOpenImg3: false,
      isOpenImg4: false,
      currentPage: 1,
      activeReportIndex: 0,
    }
  }

  componentDidMount() {
    this.initNav(this.props.index)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.index !== this.props.index) {
      this.initNav(nextProps.index)
    }
  }

  initNav = (index) => {
    this.setState({
      activeReportIndex: index,
      currentPage: Math.floor(index / 10) + 1
    })
  }

  onCloseRequest() {
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false,
      isOpenImg3: false,
      isOpenImg4: false,
    }
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    })
  }

  closeModal = (field) => {
    this.setState({
      [field]: false,
    })
  }

  changePage = (e) => {
    let activeReportIndex = (e - 1) * 10
    let record = this.props.reportList[activeReportIndex]
    this.renderReportList(e)
    this.setState({
      currentPage: e,
      activeReportIndex
    })
    this.changeReport(activeReportIndex, record)
  }

  changeReport = (index, record) => {
    this.refs.content.scrollTop = 0
    this.setState({
      activeReportIndex: index
    })
    this.props.dataSwitch(index, record)
  }

  renderReportList = (pageNumber) => {
    let { reportList } = this.props
    let reportListArr = []
    let endNum = pageNumber * 10

    if (reportList && endNum > reportList.length) {
      endNum = reportList.length
    }

    for (let currenNum = (pageNumber - 1) * 10; currenNum < endNum; currenNum++) {
      if (reportList) {
        reportListArr.push(
          <li
            key={currenNum}
            onClick={() => this.changeReport(currenNum, reportList[currenNum])}
            className={this.state.activeReportIndex === currenNum ? "active report" : "report"}
          >
            {reportList[currenNum].fileId}
          </li>
        )
      }
    }
    return reportListArr
  }

  isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0
  }

  renderResultGender = (detailData) => {
    if (detailData.resultGender !== '' && detailData.resultGender !== '无法判断') {
      return <li className='resultDetailText'>{detailData.resultGender}</li>
    } else if (detailData.resultAneu !== '' && detailData.resultAneu === '无法判断') {
      return <li className='resultDetailText'>无法判断</li>
    } else {
      return <li className='resultDetailText'>未见异常</li>
    }
  }

  renderResultAneu = (detailData) => {
    if (detailData.resultAneu !== '' && detailData.resultAneu !== '无法判断') {
      const resultAneu = detailData.resultAneu && detailData.resultAneu.split('\n')
      return (
        resultAneu && resultAneu.map((item, index) => {
          if (item !== '') {
            return (
              <li key={index} className='resultDetailText'>
                {item}
              </li>
            )
          } else {
            return null
          }
        })
      )
    } else if (detailData.resultAneu !== '' && detailData.resultAneu === '无法判断') {
      return <li className='resultDetailText'>无法判断</li>
    } else {
      return <li className='resultDetailText'>未见异常</li>
    }
  }

  renderResultCNV = (detailData) => {
    if (detailData.resultCNV !== '' && detailData.resultCNV !== '无法判断') {
      const resultCNV = detailData.resultCNV && detailData.resultCNV.split('\n')
      return (
        resultCNV && resultCNV.map((item, index) => {
          if (item !== '') {
            return <li key={index} className='resultDetailText'>{item}</li>
          } else {
            return null
          }
        })
      )
    } else if (detailData.resultAneu !== '' && detailData.resultAneu === '无法判断') {
      return <li className='resultDetailText'>无法判断</li>
    } else {
      return <li className='resultDetailText'>未见异常</li>
    }
  }

  renderResultM = (detailData) => {
    if (detailData.resultM !== '' && detailData.resultM !== undefined && detailData.resultM !== null) {
      return <li className='resultDetailText'>{detailData.resultM}</li>
    } else {
      return ''
    }
  }

  render() {
    const { isOpenImg1, isOpenImg2, isOpenImg3, isOpenImg4,currentPage } = this.state
    const { pgtaDetailData = {}, reportList } = this.props
    const columnsNewReport = [
      {
        title: "chromosome",
        dataIndex: "chromosome",
        width: 200,
        className: "ta-l"
      }, {
        title: "Median",
        dataIndex: "average",
        width: 200,
        className: "ta-l"
      }, {
        title: "Aneuploidy(mosaic)",
        dataIndex: "aneuploidy",
        className: "ta-l"
      }
    ]
    const statisticalColumns = [{
      title: "File_ID",
      dataIndex: "fileId",
      width: 170,
    }, {
      title: "Sample_Name",
      dataIndex: "sampleName",
      width: 80,
    }, {
      title: "Call_Rate",
      dataIndex: "callRate",
      width: 80,
    }, {
      title: "Total_SNP",
      dataIndex: "totalSNP",
      width: 80,
    }, {
      title: "Coverage",
      dataIndex: "coverage",
      width: 80,
    }, {
      title: "Coverage_Y",
      dataIndex: "coverageY",
      width: 80,
    }, {
      title: "SD",
      dataIndex: "sd",
      width: 80,
    }, {
      title: "PASS",
      dataIndex: "pass",
      width: 60,
    }]
    return (
      <Row type="flex" className="pgs-report-detail">
        <div ref="content" className="content">
          <div id="detailTop" className="detail-card border-left-paimary first">
            <div className="pull-right"></div>
            <div className="info-group">
              <label>数据类型：</label>
              <p>{pgtaDetailData.dataGroupName}</p>
            </div>
            <div className="info-group">
              <label>文件编号：</label>
              <p>{pgtaDetailData.fileNumber}</p>
            </div>
            <div className="info-group">
              <label>所在分组：</label>
              <p>{pgtaDetailData.dataGroupName}</p>
            </div>
          </div>
          <div className='detail-card'>
            <h3 className="border-left-primary detail-card-title">数据统计</h3>
            <Table
              columns={statisticalColumns}
              rowKey={record => record.fileId + "statistical"}
              dataSource={(!this.isEmptyObj(pgtaDetailData) && pgtaDetailData['inforStat']) ?
                [].concat(pgtaDetailData.inforStat) : []}
              pagination={false}
            />
          </div>
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">参考信息</h3>
            <Table
              columns={columnsNewReport}
              rowKey={record => record.average + "" + record.chromosome + "" + record.aneuploidy}
              dataSource={!this.isEmptyObj(pgtaDetailData) ? pgtaDetailData.chromosomeRefinfos.slice() : []}
              pagination={false}
            />
          </div>
          <div className='detail-card'>
            <div className="title-wrapper">
              <h3 className="border-left-primary detail-card-title">报告结果</h3>
            </div>
            <div className='reportResultWrap'>
              <ul>
                <li>
                  <div className='reportResultTitle'><span className='circle'></span>性染色体</div>
                  <ul className='resultDetailList'>
                    {this.renderResultGender(pgtaDetailData)}
                  </ul>
                </li>
                <li>
                  <div className='reportResultTitle'><span className='circle'></span>整倍体</div>
                  <ul className='resultDetailList'>
                    {this.renderResultAneu(pgtaDetailData)}
                  </ul>
                </li>
                <li>
                  <div className='reportResultTitle'><span className='circle'></span>CNV</div>
                  <ul className='resultDetailList'>
                    {this.renderResultCNV(pgtaDetailData)}
                  </ul>
                </li>
                <li>
                  <div className='reportResultTitle'><span className='circle'></span>补充结果</div>
                  <ul className='resultDetailList'>
                    {this.renderResultM(pgtaDetailData)}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">染色体</h3>
            <div>
              <img alt="" src={!this.isEmptyObj(pgtaDetailData) ?
                pgtaDetailData.imgWithXY.chromMiniPng :
                []}
              />
            </div>
          </div>
          <div className="detail-card">
            <div className="title-wrapper">
              <h3 className="border-left-primary detail-card-title">染色体点图</h3>
              <div>
                <a
                  className="point-link"
                  href={
        `${config.backend}/array-pgt/reports/${!this.isEmptyObj(pgtaDetailData) && pgtaDetailData.id}/charts/gc?sampleName=${pgtaDetailData.fileNumber}&fileNumber=${pgtaDetailData.inforStat ? pgtaDetailData.inforStat.sampleName : ''}`
                  }
                  target="_blank">
                  精确染色体点图
                </a>
              </div>
            </div>
            <div>
              <img
                alt=""
                className="img-hand"
                src={!this.isEmptyObj(pgtaDetailData) ? pgtaDetailData.imgWithXY.chromPointPng : []}
                onClick={() => this.setState({ isOpenImg1: true })}
              />
              {
                isOpenImg1 &&
                <Lightbox
                  mainSrc={!this.isEmptyObj(pgtaDetailData) &&
                    pgtaDetailData.imgWithXY.chromPointPng}
                  onCloseRequest={() => this.setState({ isOpenImg1: false })}
                />
              }
            </div>
            <div>
              <img
                alt=''
                className='img-hand'
                src={!this.isEmptyObj(pgtaDetailData) && pgtaDetailData.imgWithXY.chromPointSplitPng}
                onClick={() => this.setState({ isOpenImg2: true })}
              />
              {
                isOpenImg2 &&
                <Lightbox
                  mainSrc={!this.isEmptyObj(pgtaDetailData) ? pgtaDetailData.imgWithXY.chromPointSplitPng : []}
                  onCloseRequest={() => this.setState({ isOpenImg2: false })}
                />
              }
            </div>
          </div>
          <div className='detail-card'>
            <h3 className='border-left-primary detail-card-title'>BAF图</h3>
            <div>
              <img 
                alt='' 
                className='img-hand'
                src={!this.isEmptyObj(pgtaDetailData) && pgtaDetailData.imgWithXY.chromBAFPng} 
                onClick={() => this.setState({ isOpenImg3: true })}
              />
               {
                isOpenImg3 &&
                <Lightbox
                  mainSrc={!this.isEmptyObj(pgtaDetailData) ? pgtaDetailData.imgWithXY.chromBAFPng : []}
                  onCloseRequest={() => this.setState({ isOpenImg3: false })}
                />
              }
            </div>
          </div>
          <div className='detail-card'>
            <h3 className='border-left-primary detail-card-title'>LRR图</h3>
            <div>
              <img 
                alt='' 
                className='img-hand' 
                src={!this.isEmptyObj(pgtaDetailData) && pgtaDetailData.imgWithXY.chromLRRPng} 
                onClick={() => this.setState({ isOpenImg4: true })}
              />
              {
                isOpenImg4 &&
                <Lightbox
                  mainSrc={!this.isEmptyObj(pgtaDetailData) ? pgtaDetailData.imgWithXY.chromLRRPng : []}
                  onCloseRequest={() => this.setState({ isOpenImg4: false })}
                />
              }
            </div>
            
          </div>
          <div className='detail-card last'>
            <h3 className='border-left-primary detail-card-title'>染色体点图位置</h3>
            <div>
              <img alt='' src={!this.isEmptyObj(pgtaDetailData) && pgtaDetailData.imgWithXY.chromFinalPng} />
            </div>
          </div>
          {/* <div className="wrapper-download">
            <a
              href={`${config.backend}/array-pgt/reports/${!this.isEmptyObj(pgtaDetailData) &&
                pgtaDetailData.reportId}/download`}
              title="下载报告"
              className="download"
            >
              <img src={downloadIcon} alt="下载" />
            </a>
          </div> */}
        </div>
        <div className='reportNav'>
          <div className='title'>本组数据</div>
          <ul className="reports">
            {this.renderReportList(currentPage)}
          </ul>
          <Pagination
            className="pagination"
            size="small"
            pageSize={10}
            total={reportList && reportList.length}
            current={currentPage}
            onChange={(e) => { this.changePage(e) }}
          />
        </div>
      </Row>
    )
  }
}

export default ReportDetail


// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/haplotypeResult/containers/ReportDetail.js